(function () {
  'use strict';

  // Workaround: Cloud Search & Filter app reads ex-VAT prices from Shopify admin
  // and does not respect the store's tax-included setting. We display inc-VAT
  // values (× 1.25) and convert user input back to ex-VAT before the app reads it.

  var VAT_RATE = 1.25;
  var MARK_LABEL = '__csVatLabel';
  var MARK_PLACEHOLDER = '__csVatPlaceholder';
  var MARK_INPUT = '__csVatInputWrapped';
  var MARK_FILTER = '__csVatFilterObserved';

  var inputValueDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

  function parseAmount(str) {
    if (str == null || str === '') return NaN;
    var cleaned = String(str).replace(/[^\d,.\-]/g, '');
    // Danish convention: "." = thousand sep, "," = decimal sep
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    var num = parseFloat(cleaned);
    return isNaN(num) ? NaN : num;
  }

  function formatAmount(num) {
    return (Math.round(num * 100) / 100).toFixed(2).replace('.', ',');
  }

  function transformLabel(el) {
    var current = el.textContent;
    if (el[MARK_LABEL] === current) return;
    var num = parseAmount(current);
    if (isNaN(num)) return;
    var suffixMatch = current.match(/\s*([A-Za-z€£$]+)\s*$/);
    var suffix = suffixMatch ? ' ' + suffixMatch[1] : '';
    var newText = formatAmount(num * VAT_RATE) + suffix;
    if (newText === current) {
      el[MARK_LABEL] = current;
      return;
    }
    el[MARK_LABEL] = newText;
    el.textContent = newText;
  }

  function transformPlaceholder(input) {
    var placeholder = input.getAttribute('placeholder');
    if (!placeholder) return;
    if (input[MARK_PLACEHOLDER] === placeholder) return;
    var num = parseAmount(placeholder);
    if (isNaN(num)) return;
    var newPlaceholder = formatAmount(num * VAT_RATE);
    if (newPlaceholder === placeholder) {
      input[MARK_PLACEHOLDER] = placeholder;
      return;
    }
    input[MARK_PLACEHOLDER] = newPlaceholder;
    input.setAttribute('placeholder', newPlaceholder);
  }

  function wrapInput(input) {
    if (input[MARK_INPUT]) return;
    input[MARK_INPUT] = true;

    // Convert any pre-existing value (set by app from URL) from ex-VAT to inc-VAT for display.
    var rawValue = inputValueDescriptor.get.call(input);
    if (rawValue !== '' && rawValue != null) {
      var existingNum = parseAmount(rawValue);
      if (!isNaN(existingNum)) {
        inputValueDescriptor.set.call(input, formatAmount(existingNum * VAT_RATE));
      }
    }

    Object.defineProperty(input, 'value', {
      configurable: true,
      enumerable: true,
      get: function () {
        var raw = inputValueDescriptor.get.call(this);
        if (raw === '' || raw == null) return raw;
        var num = parseAmount(raw);
        if (isNaN(num)) return raw;
        return formatAmount(num / VAT_RATE);
      },
      set: function (val) {
        if (val === '' || val == null) {
          inputValueDescriptor.set.call(this, val);
          return;
        }
        var num = parseAmount(String(val));
        if (isNaN(num)) {
          inputValueDescriptor.set.call(this, val);
          return;
        }
        inputValueDescriptor.set.call(this, formatAmount(num * VAT_RATE));
      }
    });
  }

  function processPriceFilter(filterEl) {
    var minLabel = filterEl.querySelector('.cloud-search-range-slider__min');
    var maxLabel = filterEl.querySelector('.cloud-search-range-slider__max');
    if (minLabel) transformLabel(minLabel);
    if (maxLabel) transformLabel(maxLabel);

    var inputs = filterEl.querySelectorAll('.cloud-search-num-field__input');
    for (var i = 0; i < inputs.length; i++) {
      wrapInput(inputs[i]);
      transformPlaceholder(inputs[i]);
    }

    if (!filterEl[MARK_FILTER]) {
      filterEl[MARK_FILTER] = true;
      var localObserver = new MutationObserver(function () {
        processPriceFilter(filterEl);
      });
      localObserver.observe(filterEl, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['placeholder']
      });
    }
  }

  function findAndProcess(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('.cloud-search-filter') && root.querySelector('.cloud-search-range-slider')) {
      processPriceFilter(root);
    }
    if (root.querySelectorAll) {
      var filters = root.querySelectorAll('.cloud-search-filter');
      for (var i = 0; i < filters.length; i++) {
        if (filters[i].querySelector('.cloud-search-range-slider')) {
          processPriceFilter(filters[i]);
        }
      }
    }
  }

  function start() {
    findAndProcess(document.body);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type !== 'childList') continue;
        mutation.addedNodes.forEach(function (node) {
          findAndProcess(node);
        });
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
